<div class="text-start nestedbgcolor p-3 my-3">
  <p class="m-0 small"><span class="text-danger">{{ 'MISC.ATTENTION' | translate }}</span>: <span class="fw-bold">{{ 'MISC.DONOT' | translate }}</span> {{ 'MISC.SWATTENTION' | translate }} <span class="fw-bold">{{ 'DOWNLOADITEM.RELEASENOTES' | translate }}</span> {{ 'MISC.SWATTENTION1' | translate }}</p>
</div>
